import React from 'react';
import fallback from 'assets/air_bed.png';

export default ({ active, data=[], onChange=()=>{} }) => {

  const image = (image) => {

    const image_url = (!image) ? fallback : image;

    return { backgroundImage: `url(${image_url})` }

  };

  const is_active = (src) => `Thumbnail ${(src===active) ? 'active' : ''}`;

  return (
    <div className='Product-Images'>

      <div className="Thumbnail-Wrapper">
        { data.map((a,i) =>
            <div
              key={i.toString()}
              style={image(a)}
              className={is_active(a)}
              onClick={() => onChange(a)}
            />
          )
        }
      </div>

      <div
        className="Active-Image"
        style={image(active)}
      />

    </div>
  )
}
